import { classnames } from '@aibees/shared/utils';
import { Button, Stack } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { TableSequentialPaginationProps as Props } from './types';

export const TableSequentialPagination = memo(
  ({
    className,
    handleNextPage,
    handlePreviousPage,
    enabledNextButton,
    enabledPrevButton,
  }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('TableSequentialPagination', className)}
        sx={SX.root}
        direction="row"
        justifyContent="flex-end"
      >
        <Stack direction="row" gap={2}>
          <Button
            sx={SX.button}
            variant="outlined"
            onClick={handlePreviousPage}
            disabled={!enabledPrevButton}
          >
            Previous
          </Button>
          <Button
            sx={SX.button}
            variant="outlined"
            onClick={handleNextPage}
            disabled={!enabledNextButton}
          >
            Next
          </Button>
        </Stack>
      </Styled.Wrapper>
    );
  }
);

TableSequentialPagination.displayName = 'TableSequentialPagination';
